<template>
    <div class="post-filter" v-click-outside="close">
        <div class="filter-section-search" v-if="!hideSearchBar">
            <!-- <div class="container-title">
                <p class="title">Recherche</p>
            </div> -->
            <div class="input">
                <div class="container-svg"><svg xmlns="http://www.w3.org/2000/svg" width="auto" height="auto" viewBox="0 0 21 21" fill="none"><path d="M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z" fill="#E3D2EE"></path></svg></div>
                <input :placeholder="$t('dash.posts.list.search')" v-model.lazy="models.search">
            </div>
           
        </div>
        <div class="filter-section-status">
            <div class="container-title">
                <p class="title">{{ $t('dash.posts.filter.status') }} <span>({{ countStatusShow }})</span></p>
                <p class="reset" v-if="countStatusShow < 9" @click="addAllStatus">{{ $t('dash.posts.filter.show-all') }}</p>
                <p class="reset" v-else @click="removeAllStatus">{{ $t('dash.posts.filter.hide-all') }}</p>
            </div>
            <div class="list">
                <template v-for="name in ['scheduled','posted','draft','pending','failed','removed','standby', 'awaiting_approval', 'to_validate']">
                    <div class="badge-status" :status="name" :class="{disable: !filter.statusDisplay[name]}" @click="toggleStatus(name)">
                        {{ $t(`dash.post.${name}`) }}
                    </div>
                </template>
              
            </div>
        </div>
        <div class="filter-section-type">
            <div class="container-title">
                <p class="title">{{ $t('dash.posts.filter.type') }} <span>({{ countTypesShow }})</span></p>
                <p class="reset" @click="addAllTypes" v-if="countTypesShow < 6">{{ $t('dash.posts.filter.show-all') }}</p>
                <p class="reset" @click="removeAllTypes" v-else>{{ $t('dash.posts.filter.hide-all') }}</p>
            </div>
            <div class="list">
                <template v-for="type in ['image','video','reel','story','carousel', 'document']" >
                    <div class="type" :key="type">
                        <Checkbox :id="type" :prefixId="'filterPost'" :isChecked="filter.typesDisplay[type]" :remove="toggleType" :add="toggleType"/>
                        <label :for="`filterPost${type}`">{{ type }}</label>
                    </div>
                </template>

            </div>
        </div>
        <div class="filter-section-date" v-if="showDateRange">
            <div class="container-title">
                <p class="title">{{ $t('dash.posts.filter.date') }}</p>
                <p class="reset" v-if="dateRange.startDate || dateRange.endDate" @click="clearDates">{{ $t('dash.posts.filter.show-all') }}</p>
            </div>
            <div class="container-dates">
                <div class="dates">
                    <input type="date" :value="dateRange.startDate" @input="setStartDate($event.target.value)">
                    {{ $t('dash.posts.filter.date-to') }}
                    <input type="date" :value="dateRange.endDate" @input="setEndDate($event.target.value)">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Checkbox from '@/components/dash/utils/checkbox.vue';
    import ClickOutside from 'vue-click-outside'

    export default {
        components: {
            Checkbox,
        },
        props: {
            filter: Object,
            hideSearchBar: {
                default: false,
                type: Boolean
            },
            showDateRange: {
                default: false,
                type: Boolean
            }
        },

        directives: {
            ClickOutside
        },

        data() {
            return {
                models: {
                    search: ''
                }
            }
        },

        created () {
            this.$set(this.models, 'search', this.filter.search)
        },


        methods: {
            close() {
                this.$emit('close')
            },
            toggleStatus(name) {
                this.filter.statusDisplay[name] = this.filter.statusDisplay[name] ? false : true
                this.$emit('update:filter', this.filter);
                this.$emit('updateCalendar');
            },

            toggleType(name) {
                this.filter.typesDisplay[name] = this.filter.typesDisplay[name] ? false : true
                this.$emit('update:filter', this.filter);
                this.$emit('updateCalendar');
            },

            removeAllStatus() {
                for (const [statusName, bool] of Object.entries(this.filter.statusDisplay)) {
                    this.filter.statusDisplay[statusName] = false
                }
                this.$emit('update:filter', this.filter);
                this.$emit('updateCalendar');
            },

            addAllStatus() {
                for (const [statusName, bool] of Object.entries(this.filter.statusDisplay)) {
                    this.filter.statusDisplay[statusName] = true
                }
                this.$emit('update:filter', this.filter);
                this.$emit('updateCalendar');
            },

            clearTypes() {
                for (const [typeName, bool] of Object.entries(this.filter.typesDisplay)) {
                    this.filter.typesDisplay[typeName] = true
                }
                this.$emit('update:filter', this.filter);
                this.$emit('updateCalendar');
            },
            addAllTypes() {
                for (const [typeName, bool] of Object.entries(this.filter.typesDisplay)) {
                    this.filter.typesDisplay[typeName] = true
                }
                this.$emit('update:filter', this.filter);
                this.$emit('updateCalendar');
            },
            removeAllTypes() {
                for (const [typeName, bool] of Object.entries(this.filter.typesDisplay)) {
                    this.filter.typesDisplay[typeName] = false
                }
                this.$emit('update:filter', this.filter);
                this.$emit('updateCalendar');
            },

            setStartDate(val) {
                if (!this.filter.dateRange) this.$set(this.filter, 'dateRange', { startDate: null, endDate: null })
                this.filter.dateRange.startDate = val || null
                this.$emit('update:filter', this.filter)
            },
            setEndDate(val) {
                if (!this.filter.dateRange) this.$set(this.filter, 'dateRange', { startDate: null, endDate: null })
                this.filter.dateRange.endDate = val || null
                this.$emit('update:filter', this.filter)
            },
            clearDates() {
                if (!this.filter.dateRange) return
                this.filter.dateRange.startDate = null
                this.filter.dateRange.endDate = null
                this.$emit('update:filter', this.filter)
            }
        },
        
        watch: {
            ['models.search'](newValue, oldValue) {
                this.filter.search = this.models.search.trim().toLowerCase()
                this.$emit('update:filter', this.filter);
                this.$emit('updateCalendar');
            }
        },

        computed: {
            countStatusShow() {
                return Object.values(this.filter.statusDisplay).filter(v => v === true).length
            },
            countTypesShow() {
                return Object.values(this.filter.typesDisplay).filter(v => v === true).length
            },
            dateRange() {
                return (this.filter.dateRange) || { startDate: null, endDate: null }
            }
        },
    }
</script>
